import React, { Component, useState, useEffect } from "react";
import { NavMenu } from "./NavMenu";
import { SecondInnerNavMenu } from "./SecondInnerNavMenu";
import Marquee from "react-fast-marquee";
import "./../../assets/styles/Home.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import { Link } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Slider1 from "../../assets/images/Slider-1.jpg";
import Slider2 from "../../assets/images/Slider-2.jpg";
import Slider3 from "../../assets/images/slider-3.jpg";
import pdmc from "../../assets/images/onboardlogo/pdmc.png";
import videoPopup from "../../assets/images/videoPopup.jpg";
import nbb from "../../assets/images/onboardlogo/nbb.jpg";
import pmfby from "../../assets/images/onboardlogo/pmfby.png";
import nhb from "../../assets/images/onboardlogo/NHB.png";
import shc from "../../assets/images/onboardlogo/shc.png";
import ami from "../../assets/images/onboardlogo/ami.png";
import nfsm from "../../assets/images/onboardlogo/nfsm.png";
import AIF from "../../assets/images/onboardlogo/AIF.png";
import databases from "../../assets/images/database.jpg";
import transparencys from "../../assets/images/transparencys.jpg";
import friendly from "../../assets/images/friendly.jpg";
import analyticss from "../../assets/images/analyticss.jpg";
import axios from 'axios';

import abouts from '../../assets/images/incorporation.png'
//import pmKisanPopup from '../../assets/images/PMKisanApprovedwebsitepopupstill.jpeg'
import pmKisanPopup from '../../assets/images/PM-Kisan.jpeg';

//useful links
import u1 from "../../assets/images/links/1.png";
import u2 from "../../assets/images/links/2.png";
import u3 from "../../assets/images/links/3.png";
import u4 from "../../assets/images/links/4.png";
import u5 from "../../assets/images/links/5.png";
import u6 from "../../assets/images/links/6.png";
import u8 from "../../assets/images/links/8.png";
import facebook from "../../assets/images/fb.png";
import twitter from "../../assets/images/twitter.jpg";
import Instagram from "../../assets/images/instagram.png";
import koo from "../../assets/images/koo.png";
import threads from "../../assets/images/threats.png";
import youtube from "../../assets/images/youtube.png";
import linkedin from "../../assets/images/linkedin.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Photogallery from "./Photogallery";
import DownloadApp from "../../assets/images/downloadApp.jpg";
import GISHome from "../gis/GIS_home";

// Add scheme mapping configuration
const schemeConfig = [
  { name: "Agroforestry", code: "3" },
  { name: "Coconut Development Board (CDB)", code: "10" },
  { name: "Cropic", code: "01" },
  { name: "Crop Condition", code: "13" },
  { name: "Directorate of Arecanut and Spices Development (DASD)", code: "11" },
  { name: "Ground Truthing", code: "12" },
  { name: "Inspection", code: "02" },
  { name: "Mission for Integrated Development of Horticulture (MIDH)", code: "8" },
  { name: "Natural Farming (NF)", code: "6" },
  { name: "National Beekeeping and Honey Mission (NBHM)", code: "7" },
  { name: "National Mission on Edible Oils - Oil Seeds (NMEO-OS)", code: "05" },
  { name: "Per Drop More Crop (PDMC) - Micro Irrigation", code: "01" },
  { name: "Rainfed Area Development (RAD)", code: "2" },
  { name: "National mission on Edible Oils-OilPalm (NMEO-OP)", code: "14" },
  { name: "RKVY", code: "15" },
  //{ name: "M&T", code: "16" }
];
const BASE_URL = "https://km2.amnex.co.in/appdevapi/api/common";

const generateUUID = () => {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  // fallback for HTTP / old browsers
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const getSessionId = () => {
  let sessionId = sessionStorage.getItem("visitorSessionId");
  if (!sessionId) {
    sessionId = generateUUID();
    sessionStorage.setItem("visitorSessionId", sessionId);
  }
  return sessionId;
};
export const Home = () => {
   const [showPopup, setShowPopup] = useState(false);
   const [schemeData, setSchemeData] = useState({});
 
  const [allSchemeData, setAllSchemeData] = useState({});
  const [filteredSchemeData, setFilteredSchemeData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visitorCount, setVisitorCount] = useState(0);
  const [selectedFinYear, setSelectedFinYear] = useState('Select Financial Year');
  const [finYears, setFinYears] = useState(() => {
    const currentYear = new Date().getFullYear();
    const years = ['Select Financial Year','All'];
    
    // Add last 5 financial years
    for (let i = 0; i < 5; i++) {
      const startYear = currentYear - i;
      const endYear = startYear + 1;
      years.push(`${startYear}-${endYear}`);
    }
    
    return years;
  });
  // API call function
    const fetchSchemeData = async (schemeCode, finYear = '') => {
    try {
      console.log(`Fetching data for scheme: ${schemeCode}`);
      const parm = {
        schemeCode: schemeCode,
        stateCode: "0",
        districtCode: "0",
        subDistrictCode: "0",
        str_FinYear: finYear
      };
      console.log('Request body:', parm);

      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/DashboardSurveyUserCount/SurveryUserCount`,
        parm
      );
      
      console.log(`API Response for scheme ${schemeCode}:`, data);
      
      // Extract data from dataContent array
      if (data.dataContent && data.dataContent.length > 0) {
        const schemeData = data.dataContent[0];
        console.log(`Extracted scheme data for ${schemeCode}:`, schemeData);
        return {
          userCount: schemeData.userCount || 0,
          surveyCount: schemeData.surveyCount || 0
        };
      } else {
        console.log(`No data found in dataContent for scheme ${schemeCode}`);
      }
      
      return { userCount: 0, surveyCount: 0 };
    } catch (error) {
      console.error(`Error fetching data for scheme ${schemeCode}:`, error);
      return { userCount: 0, surveyCount: 0 };
    }
  };

  // Fetch data for all schemes
  const fetchAllSchemeData = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('Starting to fetch data for all schemes...');
      const promises = schemeConfig.map(async (scheme) => {
        const data = await fetchSchemeData(scheme.code);
        return {
          ...scheme,
          userCount: data.userCount || 0,
          surveyCount: data.surveyCount || 0
        };
      });

      const results = await Promise.all(promises);
      console.log('All scheme data fetched:', results);
      
      const dataMap = {};
      results.forEach(result => {
        dataMap[result.code] = result;
      });
      
      setAllSchemeData(dataMap);
      setFilteredSchemeData(dataMap); // Initially show all data
      console.log('Scheme data set in state:', dataMap);
    } catch (err) {
      setError(`Failed to fetch scheme data: ${err.message}`);
      console.error('Error fetching scheme data:', err);
    } finally {
      setLoading(false);
    }
  };

       // Test API call for debugging
  const testApiCall = async () => {
    console.log('Testing API call for scheme 14...');
    try {
      const result = await fetchSchemeData("14");
      console.log('Test API result:', result);
      alert(`Test result: UserCount: ${result.userCount}, SurveyCount: ${result.surveyCount}`);
    } catch (error) {
      console.error('Test API error:', error);
      alert(`Test failed: ${error.message}`);
    }
  };

  // Function to fetch visitor count
 const BASE_URL = "https://km2.amnex.co.in/appdevapi/api/common";

const getSessionId = () => {
  let sessionId = sessionStorage.getItem("visitorSessionId");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("visitorSessionId", sessionId);
  }
  return sessionId;
};

const fetchVisitorCount = async () => {
  // Step 1: Register visitor
  try {
    const regRes = await axios.post(
      `${BASE_URL}/RegisterVisitor`,
      { sessionId: getSessionId() },
      { headers: { accept: "*/*", "Content-Type": "application/json" } }
    );
    console.log("RegisterVisitor response:", regRes.data);
  } catch (error) {
    console.error("Error registering visitor:", error);
  }

  // Step 2: Get count
  try {
    const response = await axios.get(`${BASE_URL}/GetVisitorCount`, {
      headers: { accept: "*/*", "Cache-Control": "no-cache" },
      params: { _t: Date.now() }, // cache avoid
    });
    console.log("GetVisitorCount response:", response.data);

    const d = response.data;
    // alag-alag response formats handle karne ke liye
    const count =
      typeof d === "number" ? d :
      d?.count ??
      d?.visitorCount ??
      d?.totalCount ??
      d?.data?.count ??
      d?.data ??
      d?.dataContent?.count ??
      0;

    setVisitorCount(Number(count) || 0);
  } catch (error) {
    console.error("Error fetching visitor count:", error);
  }
};
  // Load all data on component mount
  useEffect(() => {
    fetchAllSchemeData();
    fetchVisitorCount();
     // Popup: page load pe dikhao (session me sirf ek baar)
  if (
        process.env.NODE_ENV === "development" ||
        !sessionStorage.getItem("pmKisanPopupShown")
    ) {
        setShowPopup(true);
        sessionStorage.setItem("pmKisanPopupShown", "true");
    }
  }, []);

  // Filter data when financial year changes
  useEffect(() => {
    if (selectedFinYear === 'Select Financial Year') {
      setFilteredSchemeData(allSchemeData);
      return;
    }

    const filterData = async () => {
      setLoading(true);
      try {
        const promises = schemeConfig.map(async (scheme) => {
          const data = await fetchSchemeData(scheme.code, selectedFinYear === 'All' ? '' : selectedFinYear);
          return {
            ...scheme,
            userCount: data.userCount || 0,
            surveyCount: data.surveyCount || 0
          };
        });

        const results = await Promise.all(promises);
        const dataMap = {};
        results.forEach(result => {
          dataMap[result.code] = result;
        });
        
        setFilteredSchemeData(dataMap);
      } catch (err) {
        setError(`Failed to filter data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    filterData();
  }, [selectedFinYear]);

   const settings = {
     dots: true,
     infinite: true,
     speed: 500,
     slidesToShow: 6,
     slidesToScroll: 1,
     responsive: [{
       breakpoint: 600,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 2,
         initialSlide: 2
       }
     }]
   };
return (
      <div id="target">

        {/* Image Popup */}
        {/* {showPopup && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.65)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => setShowPopup(false)}
          >
            <div
              style={{ position: 'relative', maxWidth: '90%', maxHeight: '90vh' }}
              onClick={e => e.stopPropagation()}
            >
              <button
                onClick={() => setShowPopup(false)}
                style={{
                  position: 'absolute',
                  top: '-14px',
                  right: '-14px',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  background: '#dc3545',
                  color: '#fff',
                  fontSize: '18px',
                  lineHeight: 1,
                  cursor: 'pointer',
                  zIndex: 10000,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                }}
                aria-label="Close popup"
              >
                &times;
              </button>
             <a
  href="https://www.instagram.com/reel/De0wZxjh011/?psln=a2xkejU5cmVoc3J1"
  target="_blank"
  rel="noopener noreferrer"
>
  <img
    src={pmKisanPopup}
    alt="PM Kisan"
    style={{
      maxWidth: '100%',
      maxHeight: '85vh',
      borderRadius: '8px',
      display: 'block',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      cursor: 'pointer',
    }}
  />
</a>
            </div>
          </div>
        )} */}

        <SecondInnerNavMenu />
        <div className="float-sm">
  <div className="fl-fl float-fb">
    
    <a href="https://www.facebook.com/agriGoI" target="_blank"><i className="faicon"><img src={facebook} alt="facebook"/> </i> Facebook</a>
  </div>
  <div className="fl-fl float-tw">
 
    <a href="https://twitter.com/AgriGoI" target="_blank"> <i className="faicon"><img src={twitter} alt="twitter"/> </i> Twitter</a>
  </div>
  <div className="fl-fl float-gp">
  
    <a href="https://www.instagram.com/agrigoi/" target="_blank"><i className="faicon"><img src={Instagram} alt="instagram"/> </i> Instagram</a>
  </div>
  {/* <div className="fl-fl float-rs">
  <i className="faicon"><img src={koo}/></i>
    <a href="" target="_blank">Koo</a>
  </div> */}
  <div className="fl-fl float-ig">
 
    <a href="https://www.threads.net/@agrigoi/" target="_blank"> <i className="faicon"><img src={threads} alt="threads"/></i>Threads</a>
  </div>  
  
  <div className="fl-fl float-pn">
    
    <a href="https://www.linkedin.com/company/agrigoi/" target="_blank"> <i className="faicon"><img src={linkedin} alt="Linkedin"/></i> Linkedin</a>
  </div>
  <div className="fl-fl float-yu">
     
    <a href="https://www.youtube.com/@AgriGoI" target="_blank"><i className="faicon"><img src={youtube} alt="Youtube"/></i>Youtube</a>
  </div>
</div>
<Carousel autoPlay infiniteLoop>
<div>
<img src={Slider2} alt="slider2" />
</div>
<div>
<img src={Slider3} alt="slider3" />
</div>
<div>
<img src={Slider1} alt="slider1" />
          </div>
          
</Carousel>

<section className="mainSection aboutsections">
<div className="container">
 <div className="row g-5">


{/* <div className="col-lg-6 col-md-12  fadeInUp" data--delay="0.3s">
<h3 className="text-uppercase">Farmer Data Counts</h3>
<div className="bar"></div>

<div className="leftMap_box">


<div className="row">
  <div className="col-md-12">
    <div className="homemap">
        <GISHome />
    </div>
    </div>
</div>



</div>
 </div> */}

                        <div className="col-lg-12 col-md-12  fadeInUp" data--delay="0.5s">
                            <div className="row g-5">

  

                                <div className="col-12 col-sm-6 col-lg-12 welcomeKrishiMapper">


                                    <h3 className="text-uppercase">About KrishiMApper</h3>
                                    <div className="bar"></div>
                                    <div className="rightimg_abt">
  <img src={abouts} className="img-fluid" alt='Welcome KrishiMapper' />

</div>
                                    <p className="rightimg_para">Krishi MApper is a geospatial mobile and web application for geo-fencing of agricultural land, geo-tagging of land area and collection of baseline land based scheme data to ensure right benefits reach the right beneficiaries and there is transparency in the system. It is a user friendly platform that enables valuable insights for improved farm management and evidence based monitoring. Krishi MApper platform will help the users to view the consolidated and comprehensive information pertaining to farmer's agricultural activities across schemes.</p>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </section>
      
          


 {/* <div className="howitworks p-5">
          <div className="container">
           <div className="row addbgcentr">

  <div className="col-md-3 form-group financial_home ms-auto">
                
                 
                  <select 
                    id="finYear" 
                    className="form-select finacildd_labelboxHome" 
                    value={selectedFinYear}
                    onChange={(e) => setSelectedFinYear(e.target.value)}
                   
                  >
                    {finYears.map((year) => (
                      <option key={year} value={year} style={{color: 'black'}}>{year}</option>
                    ))}
                  </select>
                </div>

               
</div>
            <div className="row">
          <div className="col-md-6 photogalleries_new">
 <h4 className="text-center">Total Surveyor Count</h4>



        <div className="barCenter mb-4"></div>
        <div className="frmerlist_count">
          {loading ? (
            <div className="text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading farmer data...</p>
            </div>
          ) : error ? (
            <div className="alert alert-danger" role="alert">
              <div className="d-flex justify-content-between align-items-center">
                <span>{error}</span>
                <button 
                  className="btn btn-outline-danger btn-sm" 
                  onClick={fetchAllSchemeData}
                >
                  Retry
                </button>
              </div>
            </div>
          ) : (
            <ul className="list-group">
           
              <li className="list-group-item d-flex justify-content-between align-items-center" style={{backgroundColor: '#f8f9fa', fontWeight: 'bold', border: '2px solid #dee2e6'}}>
                <div>
                   Scheme Name
                </div>
                <div className="d-flex align-items-center">
                  <span>Count</span>
                  
                </div>
              </li>
              {schemeConfig.map((scheme) => {
                const data = filteredSchemeData[scheme.code];
                return (
                  <li key={scheme.code} className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <i className="bi bi-list me-2 text-primary"></i> {scheme.name}
                    </div>
                    <span className="badge bg-primary rounded-pill">
                      {data ? data.userCount : 0}
                    </span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>




          </div>




          <div className="col-md-6">
          <h4 className="text-center">Total Added Farmer</h4>
           
            <div className="barCenter mb-4"></div>
            <div className="frmerlist_count">
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading surveyor data...</p>
                </div>
              ) : error ? (
                <div className="alert alert-danger" role="alert">
                  <div className="d-flex justify-content-between align-items-center">
                    <span>{error}</span>
                    <button 
                      className="btn btn-outline-danger btn-sm" 
                      onClick={fetchAllSchemeData}
                    >
                      Retry
                    </button>
                  </div>
                </div>
              ) : (
                <ul className="list-group">
                  
                  <li className="list-group-item d-flex justify-content-between align-items-center" style={{backgroundColor: '#f8f9fa', fontWeight: 'bold', border: '2px solid #dee2e6'}}>
                    <div>
                       Scheme Name
                    </div>
                    <div className="d-flex align-items-center">
                      <span>Count</span>
                      
                    </div>
                  </li>
                 {schemeConfig.map((scheme) => {
                    const data = filteredSchemeData[scheme.code];
                    return (
                      
                      <li key={scheme.code} className="list-group-item d-flex justify-content-between align-items-center">
                        <div>
                          <i className="bi bi-list me-2 text-primary"></i> {scheme.name}
                        </div>
                        <span className="badge bg-primary rounded-pill">
                          {data ? data.surveyCount : 0}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>

          </div>
          
         </div>
              </div>
              </div> */}




        <div className="sailentFeatures pb-5 pt-2"><div className="container"><h1 className="text-center">Salient Features of Krishi MApper</h1>
        {/* <p className="text-center">Please click on video section for check,<br/> How does KrishiMApper work?
        </p> */}
        <div className="barCenter"></div>
        <div className="row d-flex justify-content-center">
        <div className="col-md-3">
      <div className="card card-1">
        <img src={databases} alt="Uniform Database"/>
        <h3>Uniform Database</h3>
        <p>To create uniform land-intervention database for different schemes/program.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="card card-2">
      <img src={transparencys} alt="Transarency"/>
        <h3>Transparency</h3>
        <p>Establishing transparency of data (key attributes) across the Schemes.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="card card-3">
      <img src={analyticss} alt="Evidence-based Monitoring and Analytic"/>
        <h3>Evidence-based Monitoring and Analytic</h3>
        <p>Ability to identify farm and related information through geo-spatial information and analytics.</p>
      </div>
    </div>
    <div className="col-md-3">
      <div className="card card-4">
      <img src={friendly} alt="User Friendly"/>
        <h3>User Friendly</h3>
        <p>User friendly data capturing and<br/> monitoring techniques.</p>
      </div>
    </div>
        
          </div></div></div>

       
        <div className="theStates"><div className="container">
        {/* <p className="text-center">Please click on video section for check,<br/> How does KrishiMApper work?
        </p> */}
       
        <div className="row d-flex justify-content-center">
        <div className="col-md-12 onbordedSchemess">
        <h1 className="text-center">Schemes Onboarded on<br/> Krishi MApper</h1>
                    <div className="barCenter"></div>
                    <Slider {...settings}>
                      <div>
                      <div className="card">
               
               <a href="https://www.nfsm.gov.in/" target="_blank">
               <div className="card-body">
               <img src={nfsm} alt="National Food Security
 Mission (NFSM)"/>
               </div>
                   <h6>National Food Security
 Mission (NFSM)</h6>                 
               </a>
                 
               </div>
                      </div>
                      <div>
                      <div className="card">
             
             <a href="https://pmksy.nic.in/" target="_blank">
             <div className="card-body"><img src={pdmc} alt="PDMC"/>
             </div>
                 <h6>Per Drop More Crop<br/>
                 (PDMC)
                 </h6>
             </a>
              
             </div>
                      </div>
                      <div>
      <div className="card">
             
             <a href="https://agriinfra.dac.gov.in/" target="_blank">
             <div className="card-body"><img src={AIF} alt="AIF"/>
             </div>
                 <h6>Agriculture Infrastructure Fund<br/>(AIF)</h6>
             </a>
              
             </div>
      </div>
      <div>
      <div className="card">
             
             <a href="https://soilhealth.dac.gov.in/home" target="_blank">
             <div className="card-body"><img src={shc} alt="Soil Health Card (SHC)"/>
             </div>
             <h6>Soil Health<br/> Card (SHC)</h6>
             </a>
              
             </div>
      </div>
      <div>
      <div className="card">
               
               <a href="https://pmfby.gov.in/" target="_blank">
               <div className="card-body">
               <img src={pmfby} alt="PMFBY"/>
               </div>
                   <h6>Pradhan Mantri Fasal Bima Yojana(PMFBY)</h6>                 
               </a>
                 
               </div>
      </div>
      <div>
      <div className="card">
             
             <a href="https://nhb.gov.in/Default.aspx?enc=3ZOO8K5CzcdC/Yq6HcdIxJhqz7e6GQcTK1J92dLzA2o=" target="_blank">
             <div className="card-body"><img src={nhb} alt="NHB Inspection"/>
             </div>
                 <h6>Inspection<br/> (NHB)</h6>
             </a>
              
             </div>
      </div>
   
      <div>
      <div className="card">
             
             <a href="https://dmi.gov.in/" target="_blank">
             <div className="card-body"><img src={ami} alt="Agri. Marketing
Infrastructure (AMI)"/>
             </div>
             <h6>Agri. Marketing
Infrastructure (AMI)</h6>
             </a>
              
             </div>
      </div>
      <div>
      <div className="card">
               
               <a href="https://www.nfsm.gov.in/" target="_blank">
               <div className="card-body">
               <img src={nfsm} alt="National Food Security
 Mission (NFSM)"/>
               </div>
                   <h6>National Food Security
 Mission (NFSM)</h6>                 
               </a>
                 
               </div>
      </div>
   
      <div> <div className="card">
             
             <a href="https://nbb.gov.in/" target="_blank">
             <div className="card-body"><img src={nbb} alt="National Beekeeping
and Honey Mission"/>
             </div>
                 <h6>National Beekeeping
and Honey Mission(NBHM)
</h6>
             </a>
              
             </div></div>
    </Slider>

          <div className="row mt-2">
         
       <div className="d-flex justify-content-center"><Link to="/Schemes" className="btn btn-outline-success">View More</Link> </div>
          </div>
        
        </div>
       
          </div></div></div>
       
       
        <div className="howitworks p-5">
          <div className="container">
         <div className="row">
          <div className="col-md-4 photogalleries_new">
 <h4 className="text-center">Gallery</h4>
          <div className="barCenter"></div>
        <Photogallery/>
          </div>
          <div className="col-md-5">
          <h4 className="text-center">How KrishiMApper Works?</h4>
            {/* <p className="text-center">Please click on video section to check,<br/> How KrishiMApper works?</p> */}
            <div className="barCenter mb-4"></div>
            <button data-bs-toggle="modal" data-bs-target="#howWork"><img src={videoPopup} className="img-fluid" alt="video"/> </button>
          </div>
          <div className="col-md-3">       
          <h4 className="text-center">Latest Updates</h4>
          <div className="barCenter mb-4"></div>
          <div className="usefullinks">
         
           <Marquee direction="up" pauseOnHover="true" pauseOnClick="true">
         <div>
      <ul>
        <li>
          <a href="https://krishimapper.dac.gov.in/doc/Training_on_Krishi_Mapper.pdf" target="_blank">Training on Krishi Mapper _ 19.01.2024_Revised</a>
        </li>
       
        </ul>         
         </div>
     </Marquee>
          </div>
          </div>
         </div>
              </div>
              </div>
        
     
       
        {/*<div className="clientlist">*/}
        {/*    <div className="container">*/}
        {/*    sdklgj jn*/}
        {/*    </div>*/}
        {/*</div>*/}
        
      <div className="container">
        <a href="https://play.google.com/store/apps/details?id=com.agri.krishimapper" className="downloadapps" target="_blank">
          <img src={DownloadApp} className="img-fluid d-block"/>
        </a>
      </div>
<div className="usefulllogo mb-0 pt-4">
<div className="container">
<h1 className="text-center">Useful Links</h1>
<div className="barCenter mb-2"></div>
<marquee onMouseOver={(e)=>{e.target.stop()}} onMouseOut={(e)=>{e.target.start()}} className="m-2">
  <div className="d-flex usefulinks">
   {/* <a href="https://agriwelfare.gov.in/" target="_blank"><img src={u1}/> </a> */}
   <a href="http://cashlessindia.gov.in/" target="_blank"><img src={u2} alt="Cashesss India"/> </a>
   <a href="https://pgportal.gov.in/" target="_blank"><img src={u3} alt="PG Portal"/> </a>
   <a href="https://igod.gov.in/" target="_blank"><img src={u4} alt="IGOD"/> </a>
   <a href="https://www.digitalindia.gov.in/" target="_blank"><img src={u5} alt="Digital India"/> </a>
   <a href="https://www.mygov.in/" target="_blank"><img src={u6} alt="MyGov"/> </a>
   <a href="https://www.makeinindia.com/" target="_blank"><img src={u8} alt="Make in India"/> </a>
  </div>
</marquee>
</div>
</div>

        <footer>
          <div className="footerTop">
            <div className="container d-flex justify-content-center">
              <ul className="list-group list-group-horizontal">
                <li>
                  {" "}
                  <Link to="/">Terms & Condition</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/">Website Policies</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/">Help</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/">Feedback</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/">Web Information Manager</Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/">Sitemap</Link>{" "}
                </li>
              </ul>
            </div>
          </div>
          <div className="container-fluid copyright py-4">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-sm-12 text-center  mb-3 mb-md-0">
                  Website Content Owned & Managed by Department of Agriculture &
                  Farmers Welfare | MoA&FW | Government of India, India
                </div>
                <div className="col-md-12 col-sm-12 text-center">
                  Designed and Developed by DAD/IT, Ministry of Agriculture, New
                  Delhi, India.
                </div>
                <div className="col-md-12 col-sm-12 text-center">
                  {/* Visitor Count: {31389}*/} {visitorCount} 
                </div>
              </div>
            </div>
          </div>
        </footer>
 
        <div className="modal fade" id="howWork" tabIndex="-1" aria-labelledby="howWork" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">How it's Work</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
      </div>
      <div className="modal-body">
        ...
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
      </div>
     
    );
};